var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9472_1364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.76464 1.70616L12.7646 1.69654M2.76946 4.21578L17.7694 4.18691M16.1028 4.19012L15.5352 12.9573C15.4501 14.2727 15.4075 14.9304 15.1244 15.4295C14.8752 15.869 14.4986 16.2226 14.0444 16.4438C13.5285 16.6951 12.8694 16.6964 11.5513 16.6989L9.03572 16.7037C7.7176 16.7063 7.05854 16.7076 6.54165 16.4583C6.08658 16.2388 5.70867 15.8866 5.45774 15.4481C5.17272 14.9501 5.12762 14.2925 5.0374 12.9775L4.43612 4.21258M8.61 7.95455L8.61802 12.1212M11.9433 7.94813L11.9514 12.1148",
    stroke: "#B8C5CC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9472_1364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.261475 0.0539246) rotate(-0.110297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.2fa7305d80545027336bc9beb32ec2e1.svg";
export { ForwardRef as ReactComponent };